import { PIN } from '../rcu/catalog/security';

/** Every way the PIN gate can answer. The UI maps these to copy and tone. */
export const PIN_GATE_OUTCOME = {
  OK: 'ok',
  WRONG_PIN: 'wrong_pin',
  INVALID_FORMAT: 'invalid_format',
  LOCKED_OUT: 'locked_out',
  PIN_MISMATCH: 'pin_mismatch',
  WRONG_CURRENT: 'wrong_current',
  DEVICE_ID_MISMATCH: 'device_id_mismatch',
  PIN_CHANGED: 'pin_changed',
  PIN_RESET: 'pin_reset',
} as const;

export type PinGateOutcome = (typeof PIN_GATE_OUTCOME)[keyof typeof PIN_GATE_OUTCOME];

/** Static copy per outcome. Anything needing a count is composed by the UI. */
export const PIN_GATE_MESSAGE = {
  [PIN_GATE_OUTCOME.OK]: 'Unlocked.',
  [PIN_GATE_OUTCOME.WRONG_PIN]: 'Wrong PIN.',
  [PIN_GATE_OUTCOME.INVALID_FORMAT]: `PIN must be ${PIN.LENGTH} digits.`,
  [PIN_GATE_OUTCOME.LOCKED_OUT]: 'Too many attempts. Wait for the cool-down.',
  [PIN_GATE_OUTCOME.PIN_MISMATCH]: 'The two PINs do not match.',
  [PIN_GATE_OUTCOME.WRONG_CURRENT]: 'That is not the current PIN.',
  [PIN_GATE_OUTCOME.DEVICE_ID_MISMATCH]: 'That does not match this RCU device ID.',
  [PIN_GATE_OUTCOME.PIN_CHANGED]: 'PIN changed. Use the new PIN next time.',
  [PIN_GATE_OUTCOME.PIN_RESET]: `PIN reset to ${PIN.DEFAULT}. Enter it to open the console.`,
} as const satisfies Record<PinGateOutcome, string>;

/** How often the console checks whether the idle timer has expired. */
export const IDLE_CHECK_MS = 15_000;
/** Auto-lock is configured in minutes but compared in milliseconds. */
export const MS_PER_MINUTE = 60_000;

/** Refresh rate of the lockout countdown. */
export const LOCKOUT_TICK_MS = 1_000;

/** For rendering a countdown as minutes and seconds. */
export const SECONDS_PER_MINUTE = 60;

/** Toast shown once the console locks itself. */
export const AUTO_LOCK_MESSAGE = 'Console locked after inactivity.';

/** Outcomes that mean the action worked, which is what the UI colours green. */
export const isPinGateSuccess = (outcome: PinGateOutcome | null): boolean =>
  outcome === PIN_GATE_OUTCOME.OK ||
  outcome === PIN_GATE_OUTCOME.PIN_CHANGED ||
  outcome === PIN_GATE_OUTCOME.PIN_RESET;
